import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	HotoveQueuePrp: null as boolean | null,
	KartouQueuePrp: null as boolean | null,
	MenaId: null as number | null,
	PokladnaId: null as number | null,
	PokladnakonvId: null as number | null,
	ProvozovnaId: null as number | null,
	StrednaklOzn: null as number | null,
	StrednaklOznText: null as string | null,
	Text: null as string | null,
	PrimarniMenaId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		StrednaklOzn: [],
		MenaId: [],
		PokladnakonvId: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.POKLADNA_NAKLADOVE_STEDISKO_SELECT_MAPPER](state, { data }) {
			state.edit.StrednaklOzn = data.value;
			state.edit.StrednaklOznText = data.text;
			if (!data.isClear) {
				state.edit.ProvozovnaId = data.provozovnaId;
			}
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
